// Mock data for Uniplay clone

export const heroSlides = [
  {
    id: 1,
    title: "Homem-Aranha: Um Novo Dia",
    subtitle: "Ação 2026",
    image: "https://image.tmdb.org/t/p/w1280/x0nvYzQpyJc5pdT9lMnkMuYAg0O.jpg",
    description: "Peter Parker retorna em uma nova aventura que promete abalar o multiverso da Marvel.",
    youtube: "abc99101",
  },
  {
    id: 2,
    title: "Toy Story 5",
    subtitle: "Animação 2026",
    image: "https://image.tmdb.org/t/p/w1280/mkS4gOg1qflAysvHQ7YY0OkLDip.jpg",
    description: "A turma mais amada do cinema volta com uma aventura inédita e emocionante.",
    youtube: "abc99102",
  },
  {
    id: 3,
    title: "A Odisseia",
    subtitle: "Épico 2026",
    image: "https://image.tmdb.org/t/p/w1280/muMwJAiMtReEHLKpKMWt2rMkYF7.jpg",
    description: "A lendária jornada de Ulisses ganha vida em uma superprodução épica dirigida por Christopher Nolan.",
    youtube: "abc99103",
  },
  {
    id: 4,
    title: "Star Wars: O Mandaloriano e Grogu",
    subtitle: "Aventura 2026",
    image: "https://image.tmdb.org/t/p/w1280/dNwaS0tnwgQRaQFPY5MbGxdmYXr.jpg",
    description: "Din Djarin e o pequeno Grogu retornam para uma nova e épica jornada pela galáxia.",
    youtube: "xyz98765",
  },
  {
    id: 5,
    title: "Mortal Kombat 2",
    subtitle: "Ação 2026",
    image: "https://image.tmdb.org/t/p/w1280/iILiJSRViTEcF23MHhGCbVm3mfW.jpg",
    description: "O torneio mais brutal do multiverso retorna com Johnny Cage e novos guerreiros lendários.",
    youtube: "abc33333",
  },
  {
    id: 6,
    title: "Moana",
    subtitle: "Aventura 2026",
    image: "https://image.tmdb.org/t/p/w1280/eEsiTi19EYBluPQliS3CMnBgqTj.jpg",
    description: "A corajosa navegadora ganha vida em live-action numa nova aventura pelos mares do Pacífico.",
    youtube: "abc55555",
  },
  {
    id: 7,
    title: "O Diabo Veste Prada 2",
    subtitle: "Comédia 2026",
    image: "https://image.tmdb.org/t/p/w1280/50yWyY981TyUHhoxxSEKwO70FmQ.jpg",
    description: "Miranda Priestly volta ao comando com um novo desafio: sobreviver na era digital.",
    youtube: "abc22201",
  },
];

const tmdb = (p) => `https://image.tmdb.org/t/p/w500${p}`;

export const sections = [
  {
    id: "lancamentos",
    icon: "flame",
    title: "Lançamentos 2026",
    description: "Filmes novos que acabam de sair do Cinema, atualização semanal... tudo oque chegar de novidade a gente tem!",
    items: [
      { id: "l1", type: "Filme", title: "Homem-Aranha: Um Novo Dia (2026)", image: tmdb("/x0nvYzQpyJc5pdT9lMnkMuYAg0O.jpg"), youtube: "new00001" },
      { id: "l2", type: "Filme", title: "A Odisseia (2026)", image: tmdb("/muMwJAiMtReEHLKpKMWt2rMkYF7.jpg"), youtube: "new00002" },
      { id: "l3", type: "Filme", title: "Toy Story 5 (2026)", image: tmdb("/mkS4gOg1qflAysvHQ7YY0OkLDip.jpg"), youtube: "new00003" },
      { id: "l4", type: "Filme", title: "Moana (2026)", image: tmdb("/eEsiTi19EYBluPQliS3CMnBgqTj.jpg"), youtube: "new00004" },
      { id: "l5", type: "Filme", title: "O Diabo Veste Prada 2 (2026)", image: tmdb("/50yWyY981TyUHhoxxSEKwO70FmQ.jpg"), youtube: "new00005" },
      { id: "l6", type: "Filme", title: "Star Wars: O Mandaloriano e Grogu (2026)", image: tmdb("/dNwaS0tnwgQRaQFPY5MbGxdmYXr.jpg"), youtube: "new00006" },
      { id: "l7", type: "Filme", title: "Mortal Kombat 2 (2026)", image: tmdb("/iILiJSRViTEcF23MHhGCbVm3mfW.jpg"), youtube: "new00007" },
      { id: "l8", type: "Filme", title: "Baleia Assassina (2026)", image: tmdb("/zgSfoqcfG8lVxnBuvXOC17tWqTe.jpg"), youtube: "new00008" },
      { id: "l9", type: "Filme", title: "Speed Faster: Velocidade Sem Limites (2026)", image: tmdb("/wzK9X310uch35VFy7X9uwi8foPj.jpg"), youtube: "new00009" },
      { id: "l10", type: "Filme", title: "Copan (2026)", image: tmdb("/bSgcjkUf0MJkD0rAkCfcCO1v4iv.jpg"), youtube: "new00010" },
      { id: "l11", type: "Filme", title: "Fala Com o Meu Agente! O Filme (2026)", image: tmdb("/1jbP72ucHt9gy5qEGaGU8RfMbD2.jpg"), youtube: "new00011" },
      { id: "l12", type: "Filme", title: "Patrulha Canina: Uma Aventura Dino (2026)", image: tmdb("/zyQ0KOfyuTyBYHAQ7wl7XrrOBH2.jpg"), youtube: "new00012" },
      { id: "l13", type: "Filme", title: "Águas Mortais (2026)", image: tmdb("/dWsw0X420R6ngEcVCkNlZ189Amr.jpg"), youtube: "new00013" },
      { id: "l14", type: "Filme", title: "Por Que Eu Me Casei de Novo? (2026)", image: tmdb("/bHMtdZFZztcAE5uHHhsY2pWRPB9.jpg"), youtube: "new00014" },
      { id: "l15", type: "Filme", title: "Corrida Contra o Tempo (2026)", image: tmdb("/zPlBUyu9rWhVrdiRfSClwMkmQiT.jpg"), youtube: "new00015" },
      { id: "l16", type: "Filme", title: "O Confronto dos Thundermans (2026)", image: tmdb("/6GCxZ7RXjMZbSAd0CGHAfhmpKnL.jpg"), youtube: "new00016" },
      { id: "l17", type: "Filme", title: "Camp Rock 3 (2026)", image: tmdb("/8wI9KByZtzBMWOzDFjxHPSOAuOH.jpg"), youtube: "new00017" },
      { id: "l18", type: "Filme", title: "Minions & Monstros (2026)", image: tmdb("/hTowtXrkCY7FJyoj4p91JckrJSE.jpg"), youtube: "new00018" },
      { id: "l19", type: "Filme", title: "Zico: O Samurai de Quintino (2026)", image: tmdb("/jKnQxfKsvKLUBcznDi5OOQdrPtG.jpg"), youtube: "new00019" },
      { id: "l20", type: "Filme", title: "O Afinador (2026)", image: tmdb("/bq21NGxKqV6DgHfm5j48mscM7Ai.jpg"), youtube: "new00020" },
      { id: "l21", type: "Filme", title: "O Último Grande Assalto (2026)", image: tmdb("/uIXLAdoyuNR8vhoOcei8FQePnzK.jpg"), youtube: "new00021" },
      { id: "l22", type: "Filme", title: "O Poder do Rosário (2026)", image: tmdb("/l4ijzBon0y4woXqHeCaHyNFIvHp.jpg"), youtube: "new00022" },
      { id: "l23", type: "Filme", title: "Apreensão (2026)", image: tmdb("/nrULF6tc5ky5K5aLlNkxph8DVcB.jpg"), youtube: "new00023" },
      { id: "l24", type: "Filme", title: "Jack Ryan: Guerra Fantasma (2026)", image: tmdb("/bPue4NKPiGNrIbZFeOsZfnovFAM.jpg"), youtube: "new00024" },
    ],
  },
  {
    id: "drama",
    title: "Drama",
    description: "Depois dizem que nós é quem somos dramáticos, pois temos uma enorme variedade de filmes dramáticos, ação real, baseados em histórias reais. É muita jóia rara. Confira!...",
    items: [
      { id: "d1", type: "Filme", title: "Hierarquia do Crime (2025)", image: tmdb("/vMVnLjbHy5yxJL5Pr0dikIUmG34.jpg"), youtube: "abc11023" },
      { id: "d2", type: "Filme", title: "De Olhos Bem Abertos (2025)", image: tmdb("/mgteCoPVupMqCj9HjWcWki1gZjF.jpg"), youtube: "abc12423" },
      { id: "d3", type: "Filme", title: "Icefall: Saque no Gelo (2025)", image: tmdb("/p4JtLVvZQlzcEKMfzyVCvRBidQb.jpg"), youtube: "abc12343" },
      { id: "d4", type: "Filme", title: "Deixando Neverland 2 (2025)", image: tmdb("/3ZRbU81aYrizRVm305eAzTQqZOL.jpg"), youtube: "abc12353" },
      { id: "d5", type: "Filme", title: "Meu Nome é Agneta (2026)", image: tmdb("/jFFPtC0kj3MFspj76enfKIGNxqy.jpg"), youtube: "abc12363" },
      { id: "d6", type: "Filme", title: "O Monstro da Ilha (2025)", image: tmdb("/mvGem9E8avZEg33F9csGHGBT7kM.jpg"), youtube: "abc12373" },
      { id: "d7", type: "Filme", title: "Sedução (2025)", image: tmdb("/hnftGfORrhOK6aq1JeOyyurDKPh.jpg"), youtube: "abc12383" },
      { id: "d8", type: "Filme", title: "Capitão Fantástico (2016)", image: tmdb("/t4UH0AJql4paQMq4Dlg1gk2tqhk.jpg"), youtube: "abc12393" },
      { id: "d9", type: "Filme", title: "A Filha do Meu Melhor Amigo (2011)", image: tmdb("/vcgvxKKtvkqhgAhgkv1IADipjJ2.jpg"), youtube: "abc12403" },
      { id: "d10", type: "Filme", title: "Resgate em Grande Altitude (2025)", image: tmdb("/uSRYJ3rdfQB17kZw1SV43FFQ8kl.jpg"), youtube: "abc12413" },
      { id: "d11", type: "Filme", title: "A Última Ceia (2025)", image: tmdb("/6SFoVUOPX4m32eIlkHhuIQS0umt.jpg"), youtube: "abc12420" },
      { id: "d12", type: "Filme", title: "Eles Vão te Matar (2026)", image: tmdb("/kPiqEJ8reCWKZXIWgweQd6eR2tP.jpg"), youtube: "abc12431" },
      { id: "d13", type: "Filme", title: "Nouvelle Vague (2025)", image: tmdb("/2mGChnRQd75pOWU18B26KlxFMah.jpg"), youtube: "abc12442" },
      { id: "d14", type: "Filme", title: "Halloween - O Espantalho Assassino (2025)", image: tmdb("/ouczezymhTjjs6kJS9JvUj8tvHo.jpg"), youtube: "abc12453" },
      { id: "d15", type: "Filme", title: "Push: No Limite do Medo (2025)", image: tmdb("/aIOTrlX82mYw6o6LEuMn9yUrhd2.jpg"), youtube: "abc12464" },
    ],
  },
  {
    id: "rockinrio",
    icon: "music",
    title: "Rock in Rio (Musical)",
    description: "Shows e muitas Trilhas sonoras de tirar o fôlego em Rock in Rio...",
    items: [
      { id: "r1", type: "Show", title: "Jão no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r2", type: "Show", title: "Karol G no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r3", type: "Show", title: "Avenged Sevenfold no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r4", type: "Show", title: "Barão Vermelho no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r5", type: "Show", title: "Deep Purple no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r6", type: "Show", title: "Evanescence no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r7", type: "Show", title: "Incubus no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r8", type: "Show", title: "Journey no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r9", type: "Show", title: "Paralamas do Sucesso no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
      { id: "r10", type: "Show", title: "Planet Hemp no Rock in Rio 2024", image: tmdb("/A14vDgS4jVZaV0Qk85MFBbu9gqj.jpg"), youtube: "4_0LZeOXsLM" },
    ],
  },
  {
    id: "cine",
    icon: "popcorn",
    title: "Cine Pipoca",
    description: "Aquele filme leve e divertido para passar o tempo sem compromisso.",
    items: [
      { id: "cp1", type: "Filme", title: "Super Mario Galaxy: O Filme (2026)", image: tmdb("/b3WeTp42eJSRuE4UZfyPCOJW4c.jpg"), youtube: "abc99001" },
      { id: "cp2", type: "Filme", title: "Vozes do Passado (2007)", image: tmdb("/ugLyDEl76wlGPTdLNL00FTYtfyJ.jpg"), youtube: "abc99002" },
      { id: "cp3", type: "Filme", title: "Iron Lung: Oceano de Sangue (2026)", image: tmdb("/8jRKEN3ex1H0ZsDSgqeoiytzW8O.jpg"), youtube: "abc99003" },
      { id: "cp4", type: "Filme", title: "Canadian, Sniper (2023)", image: tmdb("/cZusHVIr4uUJoPuqkV2MsgVAGzO.jpg"), youtube: "abc99004" },
      { id: "cp5", type: "Filme", title: "O Fantasma de Frankenstein (1942)", image: tmdb("/aGKJ2kjNXHCLyWKMx3b8D5kKCag.jpg"), youtube: "abc99005" },
      { id: "cp6", type: "Filme", title: "Les Cinq diables (2022)", image: tmdb("/qkow3ApkIhFWcW9czIkvnrpdeEF.jpg"), youtube: "abc99006" },
      { id: "cp7", type: "Filme", title: "The Beast (2023)", image: tmdb("/aNLGMfyhz1ZRSHMkrUvJDTkW9Oe.jpg"), youtube: "abc99007" },
      { id: "cp8", type: "Filme", title: "Último Sentinela (2023)", image: tmdb("/pD1o9B0ibENdNroYrBCQemG2jnr.jpg"), youtube: "abc99008" },
    ],
  },
  {
    id: "aventura",
    title: "Aventura e Ação",
    description: "As melhores produções de aventura e ação épica selecionadas para você.",
    items: [
      { id: "av1", type: "Série", title: "As Aventuras de Jackie Chan (2000)", image: tmdb("/149PSw4MJ0qKIVGvMHqZkT2Lojf.jpg"), youtube: "abc88001" },
      { id: "av2", type: "Série", title: "Hunyadi - Rise of the Raven (2025)", image: tmdb("/wC5S6O6FWNoUv93iW5t1KtZ3UxY.jpg"), youtube: "abc88002" },
      { id: "av3", type: "Série", title: "As Aventuras Escolhidas 2025", image: tmdb("/o0ijRDGtlfa7EFJNA8NvmOe3Y0H.jpg"), youtube: "abc88003" },
      { id: "av4", type: "Série", title: "As Aventuras de Horton 2025", image: tmdb("/vglSyl3hjcrPOZQDyINt8fJvl4J.jpg"), youtube: "abc88004" },
      { id: "av5", type: "Série", title: "As Aventuras de Tom e Jerry 2006", image: tmdb("/9TCOHLsHSr56uScnZuIQofdkSnt.jpg"), youtube: "abc88005" },
      { id: "av6", type: "Série", title: "Moranguinho: Aventuras em Tutti-Frutti 2010", image: tmdb("/ijYO5jx9BmJIR8oD9CjlopRZ56z.jpg"), youtube: "abc88006" },
      { id: "av7", type: "Série", title: "As Enroladas Aventuras da Rapunzel", image: tmdb("/joFmuHB5huWeeLUaE90lAPEyXsn.jpg"), youtube: "abc88007" },
      { id: "av8", type: "Série", title: "As Visões da Raven", image: tmdb("/5AYuv6cSBC0Iqb1Ugkfp3z3Pjyw.jpg"), youtube: "abc88008" },
      { id: "av9", type: "Série", title: "Hora de Aventura", image: tmdb("/2EMpiF1GireQHs3f9JKCFoKElju.jpg"), youtube: "abc88009" },
      { id: "av10", type: "Série", title: "Smallville: As Aventuras do Superboy (2001)", image: tmdb("/gjGwov0xDKWmoaYulwUb9tOzlOT.jpg"), youtube: "abc88010" },
      { id: "av11", type: "Série", title: "As Aventuras de Tintin", image: tmdb("/umlovDiFIbnR0mkFsDzmiHoxVOH.jpg"), youtube: "abc88011" },
      { id: "av12", type: "Série", title: "O Senhor dos Anéis: Os Anéis de Poder 2022", image: tmdb("/b5pl6GmQmTCHmZKEBhXPN0gmoAq.jpg"), youtube: "abc88012" },
    ],
  },
  {
    id: "destaques",
    title: "Destaques do Dia",
    description: "Séries que estão bombando hoje e que você não pode perder.",
    items: [
      { id: "dd1", type: "Série", title: "56 Dias 2026", image: tmdb("/bJgbL2qHhKEnDUsVVPYJ6GJfvtW.jpg"), youtube: "abc77001" },
      { id: "dd2", type: "Série", title: "Star Trek: Academia da Frota Estelar (2026)", image: tmdb("/g0cMwV9JQ2uFR7TSgiofViDtfTx.jpg"), youtube: "abc77002" },
      { id: "dd3", type: "Série", title: "Os Abandonados (2025)", image: tmdb("/uObo75pctOV4BjDRRMOBPD05SwL.jpg"), youtube: "abc77003" },
      { id: "dd4", type: "Série", title: "Pequenos Desastres 2025", image: tmdb("/sscYITzIOAfHqxgSqeBUrH8ZmCH.jpg"), youtube: "abc77004" },
      { id: "dd5", type: "Série", title: "O Novato (The Rookie) (2018)", image: tmdb("/yCPGrd6fzbftuaH97OUS6tUdE4B.jpg"), youtube: "abc77005" },
      { id: "dd6", type: "Série", title: "Diários de um Vampiro 2009", image: tmdb("/lcGQaSrWkkxGuh0JJqyN2TkuNqb.jpg"), youtube: "abc77006" },
      { id: "dd7", type: "Série", title: "O Dia em Que a Minha Vida Mudou 2024", image: tmdb("/6Vw926F9swj2XXFJOPig17ArU7C.jpg"), youtube: "abc77007" },
      { id: "dd8", type: "Série", title: "Os Caras Malvados No Pedaço (2025)", image: tmdb("/2MwexoT6ErCY8CBe80dBEV866oF.jpg"), youtube: "abc77008" },
      { id: "dd9", type: "Série", title: "Fire Country 2022 Legendado", image: tmdb("/6XnA02VRG4dhBpTZWGZuXQdYGDW.jpg"), youtube: "abc77009" },
      { id: "dd10", type: "Série", title: "Sky Rojo (2021)", image: tmdb("/uTFX9V2dct1nKjG6zhNiThPm8Tp.jpg"), youtube: "abc77010" },
      { id: "dd11", type: "Série", title: "Insomnia 2024", image: tmdb("/z4sjqU4EpvpyyOyUHJQP1FQM6ro.jpg"), youtube: "abc77011" },
      { id: "dd12", type: "Série", title: "Robin Hood 2025", image: tmdb("/aTBRFl6l1qPW34nuZ1FC3zRgfPE.jpg"), youtube: "abc77012" },
    ],
  },
  {
    id: "historias",
    title: "Grandes Histórias",
    description: "Narrativas marcantes e envolventes para maratonar agora mesmo.",
    items: [
      { id: "gh1", type: "Série", title: "Yoroi-Shinden Samurai Troopers 2026", image: tmdb("/gQDsN26g7RUibJJcgWzPvc0iTnb.jpg"), youtube: "abc66001" },
      { id: "gh2", type: "Série", title: "MF GHOST (2023)", image: tmdb("/vMnd8iqPwOOoIZ9a2RcqAHppDoq.jpg"), youtube: "abc66002" },
      { id: "gh3", type: "Série", title: "Crime de uma Dinastia: O Caso Murdaugh 2025", image: tmdb("/affclX4VpJo18y7Oq3OZj5DIqIJ.jpg"), youtube: "abc66003" },
      { id: "gh4", type: "Série", title: "Uma Loja Para Assassinos 2024", image: tmdb("/hx84Fg4I35nkxtH69e9aOmUVtdR.jpg"), youtube: "abc66004" },
      { id: "gh5", type: "Série", title: "Dexter: Ressurreição (2025)", image: tmdb("/wG6GBTreXHoBhxsFY4vVSQtYey5.jpg"), youtube: "abc66005" },
      { id: "gh6", type: "Série", title: "Lazarus 2025", image: tmdb("/j5Tvg6cF4jM2nB9YrjQ3Jiq3PBn.jpg"), youtube: "abc66006" },
      { id: "gh7", type: "Série", title: "Cortina de Fumaça (2025)", image: tmdb("/dkxMAOiRz1zjlgFAMc3P72xSB3u.jpg"), youtube: "abc66007" },
      { id: "gh8", type: "Série", title: "Memórias de uma Prisão 2023", image: tmdb("/eE2ZK7rcHi3enHn2ut46KT66xFg.jpg"), youtube: "abc66008" },
      { id: "gh9", type: "Série", title: "Homeland - Segurança Nacional", image: tmdb("/1hFGIgADHv24zyuDpByQNqspED5.jpg"), youtube: "abc66009" },
      { id: "gh10", type: "Série", title: "Diabo do Desemprego 2025", image: tmdb("/tXAy2L4SwSe2BiZqRmnf9cDyv5N.jpg"), youtube: "abc66010" },
    ],
  },
  {
    id: "survivor",
    title: "Universo Survivor",
    description: "O melhor do suspense e sobrevivência no catálogo Uniplay.",
    items: [
      { id: "sv1", type: "Série", title: "The Walking Dead: Daryl Dixon 2023", image: tmdb("/rtEFcXvfgrCYOaCEvuqxysm1r8H.jpg"), youtube: "abc55001" },
      { id: "sv2", type: "Série", title: "Casos Arquivados: Mortes no Velho Oeste 2025", image: tmdb("/q0hxuV5aa3itwMH2ezTZOdgs5C4.jpg"), youtube: "abc55002" },
      { id: "sv3", type: "Série", title: "Boardwalk Empire: O Império do Contrabando", image: tmdb("/kL6SqlVPpfAof2nQbh1VxkUuXBQ.jpg"), youtube: "abc55003" },
      { id: "sv4", type: "Série", title: "Fear the Walking Dead", image: tmdb("/vUxU39JvOHCsMhPlQTZfPWiw6sE.jpg"), youtube: "abc55004" },
      { id: "sv5", type: "Série", title: "Marvel - Jessica Jones", image: tmdb("/aSkB2d9B8vCKbjmg5Abn9uSFmio.jpg"), youtube: "abc55005" },
      { id: "sv6", type: "Série", title: "The Walking Dead: Um Novo Universo", image: tmdb("/iJc0W299BpNyfHVPSVV4goFZ3pq.jpg"), youtube: "abc55006" },
      { id: "sv7", type: "Série", title: "Detetive Alex Cross (2024)", image: tmdb("/4t2BRfqHaSKUypPV09LkMjEECpQ.jpg"), youtube: "abc55007" },
      { id: "sv8", type: "Série", title: "Roma (2005)", image: tmdb("/6TthtTTZ0H7SUkQxJIv0l9yhOOU.jpg"), youtube: "abc55008" },
      { id: "sv9", type: "Série", title: "The Walking Dead 2010", image: tmdb("/bioOPexzaYnAwa1joJn5QlAvr0H.jpg"), youtube: "abc55009" },
      { id: "sv10", type: "Série", title: "Uma Questão de Química", image: tmdb("/9lN9uhgH2YTIubfQTd2f0rtqnmp.jpg"), youtube: "abc55010" },
      { id: "sv11", type: "Série", title: "Percy Jackson e os Olimpianos 2023", image: tmdb("/63zVMAA4oxz9N8EnkNdR8gpyjKf.jpg"), youtube: "abc55011" },
      { id: "sv12", type: "Série", title: "Walker", image: tmdb("/gYXgu5zGAKx5IBk8CLx44Cjaw99.jpg"), youtube: "abc55012" },
    ],
  },
];

export const liveChannels = [
  { id: "c1", name: "Jogos de Hoje", category: "Futebol • Destaque", hot: true, image: "https://img.cdndsgni.com/preview/12696854.jpg" },
  { id: "c2", name: "Premiere 1 HD", category: "Brasileirão", hot: true, image: "https://cdn.mitvstatic.com/programs/br-premiere_p_m.jpg" },
  { id: "c3", name: "SporTV HD", category: "Esportes", hot: true, image: "https://logodownload.org/wp-content/uploads/2014/09/sportv-logo-4.png" },
  { id: "c4", name: "ESPN Brasil HD", category: "Esportes", hot: true, image: "https://logodownload.org/wp-content/uploads/2014/07/espn-logo-1.png" },
  { id: "c5", name: "ESPN 2 HD", category: "Esportes", image: "https://logodownload.org/wp-content/uploads/2014/07/espn-logo-1.png" },
  { id: "c6", name: "TNT Sports HD", category: "Champions League", hot: true, image: "https://logodownload.org/wp-content/uploads/2014/09/tnt-logo-4.png" },
  { id: "c7", name: "Cazé TV", category: "Futebol Grátis", image: "https://yt3.googleusercontent.com/wCLpjJmwWLNMHrPRRjKuvcvflAQPWH8xn6ycvW4hZ1EDLYFqZgs4uAvJq5FZHqvEXjmZRSPz=s900-c-k-c0x00ffffff-no-rj" },
  { id: "c8", name: "DAZN", category: "Esportes", image: "https://logodownload.org/wp-content/uploads/2020/09/dazn-logo-0.png" },
  { id: "c9", name: "Combate HD", category: "MMA / UFC", image: "https://logodownload.org/wp-content/uploads/2018/09/combate-logo.png" },
  { id: "c10", name: "GLOBO RJ HD", category: "Variedades", hot: true, image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQJCmNFzJX6VLq7oudjN_ND4VJVFvi9CdXGg&s" },
  { id: "c11", name: "SBT RJ HD", category: "Variedades", image: "https://static.sbt.com.br/programas/logos/vertical/129.jpg" },
  { id: "c12", name: "RECORD RJ HD", category: "Variedades", image: "https://cdn.mitvstatic.com/programs/br_rj-record_p_m.jpg" },
  { id: "c13", name: "BAND RJ HD", category: "Variedades", image: "https://media.licdn.com/dms/image/v2/D4D22AQHQiXd1_TAO1Q/feedshare-shrink_800/feedshare-shrink_800/0/1685817473577?e=2147483647&v=beta&t=yx-e3X95bOtTlOYjGMufft2RcSUw2oqN6JkKuPHLx-g" },
  { id: "c14", name: "DISCOVERY CHANNEL HD", category: "Documentários", image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSba0-IooQWdR3CHziw_19oONIyB6IpffPAtbNwBR-44Q&s" },
  { id: "c15", name: "Fox Sports HD", category: "Esportes", image: "https://logodownload.org/wp-content/uploads/2016/09/fox-sports-logo-2.png" },
  { id: "c16", name: "Band Sports HD", category: "Esportes", image: "https://logodownload.org/wp-content/uploads/2015/04/bandsports-logo-2.png" },
];

export const activeRooms = [
  { id: 1, master: "@romulo17f2", user: "Jonas", code: "K-45" },
  { id: 2, master: "@romulo17f2", user: "Dionilson", code: "B-68" },
  { id: 3, master: "@romulo17f2", user: "Andrade", code: "Q-26" },
  { id: 4, master: "@brunessa85a2", user: "Nando", code: "V-60" },
  { id: 5, master: "@romulo17f2", user: "Robson", code: "L-52" },
  { id: 6, master: "@brunessa85a2", user: "Igor", code: "C-78" },
  { id: 7, master: "@brunessa85a2", user: "Julia", code: "C-05" },
  { id: 8, master: "@brunessa85a2", user: "Julia", code: "A-69" },
  { id: 9, master: "@romulo17f2", user: "Julia", code: "S-48" },
  { id: 10, master: "@romulo17f2", user: "Marcelo", code: "O-81" },
  { id: 11, master: "@brunessa85a2", user: "Marcelo", code: "U-63" },
  { id: 12, master: "@brunessa85a2", user: "Daniel", code: "L-60" },
  { id: 13, master: "@brunessa85a2", user: "Marcelo", code: "Y-13" },
  { id: 14, master: "@romulo17f2", user: "Mayllon", code: "R-03" },
  { id: 15, master: "@romulo17f2", user: "Bruno", code: "S-27" },
  { id: 16, master: "@brunessa85a2", user: "Marlon", code: "T-28" },
  { id: 17, master: "@brunessa85a2", user: "Haroldo", code: "S-04" },
  { id: 18, master: "@brunessa85a2", user: "Andre luiz", code: "T-87" },
  { id: 19, master: "@brunessa85a2", user: "Edilma", code: "J-46" },
  { id: 20, master: "@romulo17f2", user: "Jose", code: "X-57" },
];

export const actors = [
  "Adriana Esteves", "Adrien Brody", "Anna Kendrick", "Ashley Greene", "Bill Bixby", "Bren Foster",
  "Bruce Dern", "Bruce Willis", "Caleb McLaughlin", "Candace Cameron Bure", "Carmen Machi", "Cauã Reymond",
  "Charlize Theron", "Chris Pratt", "Christopher Lambert", "Colin Farrell", "Courteney Cox", "Cynthia Erivo",
  "Débora Falabella", "Elizabeth Debicki", "Emílio Dantas", "Esther Supreeleela", "Gabrielle Union",
  "Gerard Butler", "Gui Nery", "Isabel May", "Jake Gyllenhaal", "Javier Cámara", "Javier Gutiérrez",
  "Jean Reno", "Lauren Cohan", "Marcello Novaes", "Marcelo Adnet", "Mario Casas", "Mark Dacascos",
  "Michelle Rodriguez", "Morena Baccarin", "Murilo Benício", "Nanda Costa", "Natalie Martinez",
  "Neve Campbell", "Norman Reedus", "Patricia Arquette", "Ralph Fiennes", "Renato Aragão",
  "Ron Perlman", "Samuel L. Jackson", "Sandra Bullock", "Sean Connery", "Taron Egerton",
  "Tyrese Gibson", "Viola Davis", "Wagner Moura", "Zazie Beetz",
];

export const categories = [
  { name: "Filmes | Adultos Gay +18", count: 77 },
  { name: "Filmes | Adultos Hentai +18", count: 40 },
  { name: "Filmes | Adultos Lesb +18", count: 32 },
  { name: "Filmes | Adultos Trans +18", count: 25 },
  { name: "Filmes | Apple TV+", count: 400 },
  { name: "Filmes | Copa Do Mundo 2022", count: 64 },
  { name: "Filmes | Crime", count: 79 },
  { name: "Filmes | GloboPlay", count: 205 },
  { name: "Filmes | Guerra", count: 57 },
  { name: "Filmes | Lançamentos 2026", count: 96 },
  { name: "Filmes | Legendados", count: 3369 },
  { name: "Filmes | Nacional", count: 258 },
  { name: "Filmes | Paramount +", count: 102 },
  { name: "Filmes | Star +", count: 10 },
  { name: "Séries | Dorama", count: 377 },
  { name: "Séries | Legendado", count: 158 },
  { name: "Séries | Novelas Mexicanas", count: 20 },
  { name: "Séries | Star +", count: 121 },
  { name: "Séries | Treine em Casa - Aulas", count: 11 },
  { name: "Filmes | DC Comics", count: 32 },
  { name: "Filmes | 4K", count: 786 },
  { name: "Filmes | Adultos +18", count: 1072 },
  { name: "Filmes | Animação", count: 228 },
  { name: "Filmes | Anime", count: 92 },
  { name: "Filmes | Aventura", count: 225 },
  { name: "Filmes | Ação", count: 968 },
  { name: "Filmes | Brasil Paralelo", count: 18 },
  { name: "Filmes | Cinema", count: 8 },
  { name: "Filmes | Comedia", count: 1551 },
  { name: "Filmes | Documentarios", count: 457 },
  { name: "Filmes | Drama", count: 1385 },
  { name: "Filmes | Fantasia", count: 375 },
  { name: "Filmes | Faroeste", count: 164 },
  { name: "Filmes | Ficção", count: 274 },
  { name: "Filmes | Infantil", count: 849 },
  { name: "Filmes | Lançamentos 2025", count: 644 },
  { name: "Filmes | Marvel", count: 43 },
  { name: "Filmes | Prime Video", count: 1426 },
  { name: "Filmes | Religioso", count: 99 },
  { name: "Filmes | Romance", count: 329 },
  { name: "Filmes | Suspense", count: 441 },
  { name: "Filmes | Terror", count: 1175 },
  { name: "Filmes/Disney+", count: 183 },
  { name: "Filmes/HBOmax", count: 174 },
  { name: "Filmes/Netflix", count: 553 },
  { name: "Shows", count: 88 },
  { name: "Shows Rock in Rio 2024", count: 99 },
  { name: "Stand Up Comedy", count: 25 },
  { name: "Séries | Animação", count: 58 },
  { name: "Séries | Animes", count: 480 },
  { name: "Séries | Apple TV", count: 130 },
  { name: "Séries | Crunchyroll", count: 47 },
  { name: "Séries | Desenhos", count: 267 },
  { name: "Séries | Disney +", count: 288 },
  { name: "Séries | Documentarios", count: 264 },
  { name: "Séries | Globoplay", count: 272 },
  { name: "Séries | HBO MAX", count: 420 },
  { name: "Séries | Netflix", count: 1240 },
  { name: "Séries | Novelas", count: 430 },
  { name: "Séries | Novelas e Séries Turcas", count: 122 },
  { name: "Séries | Paramount", count: 160 },
  { name: "Séries | Prime Video", count: 385 },
  { name: "Séries | Reality show", count: 221 },
];
